import useStoredImage from "../../hooks/useStoredImage";

export function getHighlightPostFromImpression(impression: any) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getHighlightImageSrc } = useStoredImage();

  const highlightsByReportableId: any = {
    LUCROS_AUMENTANDO: {
      content:
        "Ao infinito, e além! O ativo acaba de atingir uma alta de mais de 30% de acumulação, na sua opinião, até onde isso vai?",
      image: getHighlightImageSrc("infinito_e_alem.jpg"),
    },
  };

  return highlightsByReportableId[impression.reportableIdentification];
}
